<div class="container-fluid mt-4">
  <div class="row">
    <div class="col-12">
      <h2 class="subtitle-page">Conceptos</h2>
    </div>
  </div>

  <!-- Modal para agregar los conceptos -->
  <div class="row mt-3">
    <div class="col-12 text-end">
      <app-modal-agregar-concepto (sendConceptos)="receiveConceptos($event, false)"></app-modal-agregar-concepto>
    </div>
  </div>


  <!-- Tabla de los conceptos -->
  <div class="row mt-3">
    <div class="col-12">
      <div class="table-container">
        <table class="table table-striped table-sm w-100">
          <caption></caption>
          <thead>
            <tr>
              <th class="text-center" id="table-conceptos-thead-1" style="font-size: 14px;">Cantidad</th>
              <th class="text-center" id="table-conceptos-thead-2" style="font-size: 14px;">Clave Producto/Servicio</th>
              <th class="text-center" id="table-conceptos-thead-3" style="font-size: 14px;">Descripcion</th>
              <th class="text-center" id="table-conceptos-thead-4" style="font-size: 14px;">Valor Unitario</th>
              <th class="text-center" id="table-conceptos-thead-5" style="font-size: 14px;">Descuento</th>
              <th class="text-center" id="table-conceptos-thead-6" style="font-size: 14px;">Importe</th>
              <th class="text-center" id="table-conceptos-thead-7" style="font-size: 14px;">Objeto Imp</th>
              <th class="text-center" id="table-conceptos-thead-8" style="font-size: 14px;">Opcion</th>
            </tr>
          </thead>
          <tbody>
            @for (concepto of listConceptos.value; track $index) {
              <tr>
                <td class="text-center" style="font-size: 12px;">{{ concepto.cantidad }}</td>
                <td class="text-center" style="font-size: 12px;">{{ concepto.claveProdServ }}</td>
                <td style="font-size: 12px;">{{ concepto.descripcion }}</td>
                <td class="text-end" style="font-size: 12px;">{{ concepto.valorUnitario | currency }}</td>
                <td class="text-end" style="font-size: 12px;">{{ concepto.descuento | currency }}</td>
                <td class="text-end" style="font-size: 12px;">{{ concepto.importe | currency }}</td>
                <td class="text-center" style="font-size: 12px;">{{ concepto.objetoImp }}</td>
                <td class="text-center" style="font-size: 12px;"><a (click)="deleteConcepto($index)" class="text-danger" title="Eliminar concepto" style="cursor: pointer;"><i class="fas fa-trash"></i></a></td>
              </tr>
            }@empty {
              <tr>
                <td [colSpan]="8" class="text-center" style="font-size: 12px;">Aún no se añaden conceptos</td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <th class="text-end" id="table-conceptos-tfoot-9" style="font-size: 14px;" colspan="6">Sub Total:</th>
              <td class="text-end" style="font-size: 14px;" colspan="2">{{ subtotalEncabezado | currency }}</td>
            </tr>
            <tr>
              <th class="text-end" id="table-conceptos-tfoot-10" style="font-size: 14px;" colspan="6">Total Impuestos Traslados:</th>
              <td class="text-end" style="font-size: 14px;" colspan="2">{{ impuestosDesagrupados.traslados | currency }}</td>
            </tr>
            <tr>
              <th class="text-end" id="table-conceptos-tfoot-11" style="font-size: 14px;" colspan="6">Total Impuestos Retenidos:</th>
              <td class="text-end" style="font-size: 14px;" colspan="2">{{ impuestosDesagrupados.retenciones | currency }}</td>
            </tr>
            <tr>
              <th class="text-end" id="table-conceptos-tfoot-12" style="font-size: 14px;" colspan="6">Total:</th>
              <td class="text-end" style="font-size: 14px;" colspan="2">{{ totalEncabezado | currency }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>

<app-custom-toaster />